import { useQuery } from '@tanstack/react-query';
import { payrollHistoryService, type PayrollRunFilters } from '@/services/payroll/payrollHistoryService';
import { payrollKeys } from './queryKeys';

export function usePayrollRuns(filters?: PayrollRunFilters) {
  return useQuery({
    queryKey: [...payrollKeys.runs(), filters],
    queryFn: () => payrollHistoryService.getPayrollRuns(filters),
    staleTime: 30000, // 30 seconds
  });
}

export function usePayrollRunDetails(runId: string) {
  return useQuery({
    queryKey: payrollKeys.run(runId),
    queryFn: () => payrollHistoryService.getPayrollRunDetails(runId),
    enabled: !!runId,
    staleTime: 60000, // 1 minute
  });
}

export function useRunPayslips(runId: string) {
  return useQuery({
    queryKey: [...payrollKeys.run(runId), 'payslips'],
    queryFn: () => payrollHistoryService.getRunPayslips(runId),
    enabled: !!runId,
    staleTime: 60000, // 1 minute
  });
}
